module.exports = "/_next/static/images/gurda-2cd54348d1a474b3da8be1b4d39bf340.png";